export default {
  // Label
  L_LOGIN: "Đăng nhập",
  L_SYSTEM_LOGIN: "Đăng nhập hệ thống",
  L_OK: "Đồng ý",
  L_CANCEL: "Hủy",
  L_CONFIRM: "Xác nhận",
  L_UPDATE: "Cập nhật",
  L_PASSWORD: "Mật khẩu",
  L_CHANGE_PASSWORD: "Đổi mật khẩu",
  L_CURRENT_PASSWORD: "Nhập mật khẩu hiện tại",
  L_NEW_PASSWORD: "Mật khẩu mới",
  L_RE_NEW_PASSWORD: "Nhập lại mật khẩu mới",
  L_ENTER_VALIDATION: "Nhập xác thực",
  L_SEARCH: "Tìm kiếm",
  L_DATETIME: "Thời gian",
  L_PROFILE: "Thông tin cá nhân",
  L_FULLNAME: "Họ và tên",
  L_PHONE_NUMBER: "Số điện thoại",
  L_DEPARTMENT: "Phòng ban",
  L_UNIT: "Đơn vị",
  L_SUPERVISOR: "Cán bộ giám sát",
  L_EMAIL: "Email",
  L_ADD: "Thêm",
  L_CONTINUE: "Tiếp tục",
  L_USER: "Người dùng",
  L_ADD_USER: "Thêm người dùng",
  L_NO_DATA: "Không có dữ liệu",
  L_LOADING: "Đang tải dữ liệu",
  L_NEW: "Mới",
  L_SUCCESS: "Thành công",
  L_FAILURE: "Thất bại",
  L_WAITING_TO_PROCESS: "Đang chờ xử lý",

  // Format
  /**
   * Examplef
   * FM_ZERO: "{{total}} Hero",
   */

  // Message
  /**
   * Example
   * MSG_SUCCESS: "You have successfully!",
   * MSG_ERROR: "Something Wrong!",
   */
  MSG_LOGIN_FAILED: "Email hoặc mật khẩu không đúng",
  MSG_UPDATE_SUCCESS: "Cập nhật thành công",
  MSG_UPDATE_FAILURE: "Cập nhật thất bại",
  MSG_UPDATE_PASSWORD_SUCCESS: "Cập nhật mật khẩu thành công",
  MSG_UPDATE_PASSWORD_FAILURE: "Mật khẩu hiện tại không chính xác",
  MSG_CONFIRM_PASSWORD_FAILURE: "Mật khẩu mới không trùng khớp",
  MSG_ERROR: "Đã xảy ra lỗi, vui lòng thử lại",
  MSG_UPLOAD_SUCCESS: "Tải lên thành công",
  MSG_UPLOAD_FAILURE: "Tải lên thất bại",
  MSG_ADD_SUCCESS: "Thêm mới thành công",
  MSG_ADD_FAILURE: "Thêm mới thất bại",

  // Object structure
  /**
   * Example
   * OBJ_LOADING_STATUS: {
   *    confirming: "Confirming...",
   *    success: "Success",
   *    processing: "Processing...",
   *    failed: "Failed",
   *    canceled: "Canceled",
   * }
   */
  OBJ_STATUS_USER: {
    inactive: "Không hoạt động",
    active: "Hoạt động",
  },
  OBJ_STATUS_REQUEST: {
    all: "Tất cả",
    created: "Mới",
    processing: "Đang chờ xử lý",
    success: "Hoàn thành",
    failed: "Thất bại",
    rejected: "Từ chối",
    resolved: "Xác nhận",
  },
  OBJ_MENU_PAGE: {
    home: "Trang chủ",
    requestManagement: "Quản lý truy vấn",
    searchManagement: "Quản lý tìm kiếm",
    responseManagement: "Quản lý phản hồi",
    internalRequestList: "Truy vấn nội bộ",
    externalRequestList: "Truy vấn bên ngoài",
    identitySearchList: "Danh sách tìm kiếm theo CCCD",
    sailorSearchList: "Danh sách tìm kiếm theo mã thuyền viên",
    shipSearchList: "Danh sách tìm kiếm theo biển số tàu",
    identityResponseList: "Danh sách phản hồi truy vấn CCCD",
    sailorResponseList: "Danh sách phản hồi truy vấn thuyền viên",
    violationResponseList: "Danh sách phản hồi truy vấn tàu thuyền vi phạm",
    userManagement: "Quản lý người dùng",
    appManagement: "Quản lý ứng dụng",
    deviceManagement: "Quản lý thiết bị",
    systemLog: "Nhật ký hệ thống",
  },
  OBJ_MENU_HEADER: {
    info: "Thông tin cá nhân",
    logout: "Đăng xuất",
  },
  OBJ_SOURCE: {
    internal: "Mạng trong",
    external: "Mạng ngoài",
  },
  OBJ_CHECK_NETWORK: {
    ONLINE: {
      title1: "Khôi phục trạng thái dữ liệu",
      des1: "✅ Mạng đã được khôi phục — Đang khôi phục đồng bộ dữ liệu",
      title2: "Đồng bộ dữ liệu",
      des2: "Đang xử lý xung đột...",
      title3: "Báo cáo tình trạng",
      des3: "✅ Không có bản ghi nào chưa đồng bộ",
    },
    OFFLINE: {
      title1: "Lưu trữ dữ liệu",
      des1: "⚠️ Bạn đang offline — Đang thực hiện lưu trữ dữ liệu",
      title2: "Đánh dấu dữ liệu chưa đồng bộ",
      des2: "Đang thực hiện đánh dấu dữ liệu",
    },
  },
};
